import { Component, Input, OnChanges } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { CellData, ComponentData, TableData } from '@ddt-web/data-service';

import { PerformanceUtil } from '../utils/performance.util';

@Component({
	selector: 'perf-fees',
	templateUrl: './fees.component.html',
	styleUrls: ['./fees.component.scss']
})
export class FeesComponent implements OnChanges {
	@Input() public data: ComponentData;
	@Input() public overviewData: ComponentData;

	@Input() public filterInvalidPortfolioData: boolean = false;
	@Input() public showAssetClasses: boolean = true;
	@Input() public mode?: string;
	@Input() public holdingsAsOfDateData?: TableData;
	// Input needed for filtering data based on a search form control input
	@Input() public searchFormControl?: UntypedFormControl;
	@Input() public showPagination?: boolean = false;
	@Input() public isDisclosureExpandable?: boolean = false;
	@Input() public defaultPageSize?: number;
	@Input() public defaultSortKey?: string;

	public validPortfolioData: CellData[][];
	public selectedPortfolioIndex: number = 0;
	public searchInput = new UntypedFormControl();

	public ngOnChanges(): void {
		if (!this.selectedPortfolioIndex) {
			this.selectedPortfolioIndex = 0;
		}
		this.validPortfolioData = PerformanceUtil.getFilteredPortfolioData(this.data.portfolioData, !this.showAssetClasses, this.filterInvalidPortfolioData);
	}

	public selectPortfolioToView(index: string): void {
		this.searchInput.setValue('');
		this.selectedPortfolioIndex = Number.parseInt(index, 10);
	}
}
